const partnersMetadata = {
	supersim: {
		logo: "supersim",
		primaryColor: "#FF6D00",
	},
};

export default partnersMetadata;
